import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/data_orders",
    name: "data_orders",
    redirect: "/data_orders/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "data_orders_index",
        meta: {title: "结果订单", isIndex: true, keepAlive: true},
        component: () => import("@/pages/data/orders/index")
      }
    ]
  },
  {
    path: "/data_ordertotal",
    name: "data_ordertotal",
    redirect: "/data_ordertotal/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "data_ordertotal_index",
        meta: {title: "订单汇总", isIndex: true, keepAlive: true},
        component: () => import("@/pages/data/ordertotal/index")
      }
    ]
  },

  {
    path: "/data_skujudge",
    name: "data_skujudge",
    redirect: "/data_skujudge/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "data_skujudge_index",
        meta: {title: "商品洞察", isIndex: true, keepAlive: true},
        component: () => import("@/pages/data/skujudge/index")
      }
    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/data.js